<template>
  <span>
    <b-row>
      <b-col>
        <add-from-stock @row-click="addRowsIn($event)" />

        <b-button class="mx-1 font-weight-bold" style="color: black" disabled variant="info">
          {{ ((100 * totalExportable) / totalInNet).toFixed(2) }}% Embalaje
        </b-button>
        <b-button class="mx-1 font-weight-bold" style="color: black" disabled variant="danger">
          {{ ((100 * totalWaste) / totalInNet).toFixed(2) }}% Merma
        </b-button>
        <label-form></label-form>
        <saca-cajas
          :process_id="parseInt($route.params.id)"
          v-if="$store.state.user.scope.includes('bluefields-stock-cajas')"
        ></saca-cajas>

        <barcode-scanner class="float-right" @on-scan="handleBarcode"></barcode-scanner>
      </b-col>
    </b-row>
  </span>
</template>

<script>
import AddFromStock from "./AddFromStock";
import SacaCajas from "../../components/clientCustomComponents/bluefields/SacaCajas.vue";
import LabelForm from "./LabelForm.vue";
import BarcodeScanner from "../reusable/BarcodeScanner";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  name: "MainButtons",
  components: {
    AddFromStock,
    LabelForm,
    BarcodeScanner,
    SacaCajas
  },
  computed: {
    ...mapGetters("alfaberriesProcess", ["totalWaste", "totalExportable", "totalOutNet", "totalInNet"])
  },
  methods: {
    handleBarcode(e) {
      Swal.fire({
        title: "Scanner",
        text: `Intentando ingresar pallet ${e} a la línea.`,
        timer: 2000,
        timerProgressBar: true
      });
      let evt = { pallet_number: e };
      this.addRowsIn(evt);
    },
    addRowsIn(e) {
      this.$emit("add-rows-in", e);
    },
    showModal(id) {
      this.$bvModal.show(id);
    }
  }
};
</script>

<style scoped></style>
